export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const LOGOUT = 'LOGOUT';

export const authRequest = () => ({
  type: AUTH_REQUEST
});

export const authSuccess = response => ({
  type: AUTH_SUCCESS,
  payload: response
});

export const authFailure = () => ({
  type: AUTH_FAILURE
});

export const loginRequest = (email, password) => ({
  type: LOGIN_REQUEST,
  payload: { email, password }
});

export const loginSuccess = response => ({
  type: LOGIN_SUCCESS,
  payload: response
});

export const loginFailure = err => ({
  type: LOGIN_FAILURE,
  payload: err,
  error: true
});

export const forgotPasswordRequest = email => ({
  type: FORGOT_PASSWORD_REQUEST,
  payload: { email }
});

export const forgotPasswordSuccess = response => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: response
});

export const forgotPasswordFailure = err => ({
  type: FORGOT_PASSWORD_FAILURE,
  payload: err,
  error: true
});

export const resetPasswordRequest = payload => ({
  type: RESET_PASSWORD_REQUEST,
  payload
});

export const resetPasswordSuccess = response => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: response
});

export const resetPasswordFailure = err => ({
  type: RESET_PASSWORD_FAILURE,
  payload: err,
  error: true
});

export const logout = () => ({
  type: LOGOUT
});



// WEBPACK FOOTER //
// ./src/store/auth/actions.js